import { get } from 'src/axios/post'
import { reset, wait } from 'src/store'

const loggedInStates = () => {
  return [
    'staff',
    'needsReloading',
    'loading'
  ]
}

const defaultStates = () => {
  return {
    staff: [],
    needsReloading: true,
    loading: false
  }
}

export default {
  namespaced: true,
  state: defaultStates(),
  mutations: {
    reset (state) {
      reset(state, loggedInStates(), defaultStates())
    },
    setLoading (state, val) {
      state.loading = Boolean(val)
    },
    setNeedsReloading (state, val) {
      state.needsReloading = Boolean(val)
    },
    setStaff (state, staff) {
      state.staff = staff
      state.needsReloading = false
    }
  },
  actions: {
    async getStaff ({ commit, state }) {
      if (state.loading || !state.needsReloading) {
        if (state.loading) {
          await wait(state, 'loading')
        }
        return
      }
      commit('setLoading', true)
      const { status, payload } = await get('v1/business/company/users/all')
      commit('setLoading', false)
      if (status === 'success') {
        commit('setStaff', payload.users)
      }
    }
  },
  getters: {
    getStaff: state => state.staff,
    isLoading: state => state.loading,
    needsReloading: state => state.needsReloading
  }
}
